export const loadAllConversationMessages = async ({
  conversationId,
  fetchPage,
  isStale = () => false,
}) => {
  let before;
  let messages = [];

  do {
    // Sequential cursors are required because each page supplies the next `before` value.
    // eslint-disable-next-line no-await-in-loop
    const { data } = await fetchPage({ conversationId, before });
    if (isStale()) return null;

    const page = data?.payload || [];
    messages = [...page, ...messages];
    before = page[0]?.id;
    if (page.length < 20) break;
  } while (before);

  return messages;
};
